/**
 * Tenancy for log records, pushed in by the app rather than imported.
 *
 * `logging.ts` is evaluated before the rest of the app, so importing the configuration graph to read the
 * selected customer would evaluate that graph first, and any module in it holding a logger would reach a
 * half-initialised `logging.ts` and throw. Hence the one-way dependency, and hence no imports here but
 * types. Until the app registers a resolver, records carry no tenancy - which is accurate, since no
 * customer is selected yet.
 */

export type TenancyResolver = () => Record<string, unknown>;

let resolveRegisteredTenancy: TenancyResolver = () => ({});

export const registerTenancyResolver = (resolver: TenancyResolver): void => {
    resolveRegisteredTenancy = resolver;
};

export const resolveTenancy = (): Record<string, unknown> => resolveRegisteredTenancy();
